<template>
  <div>
    <div class="fullscreen-image">
      <v-btn fab small class="buttons mr-5" @click="$emit('change-image', 'PREVIOUS')">
        <v-icon>arrow_left</v-icon>
      </v-btn>

      <div class="fullscreen-image__inner">
        <img alt="fullscreen image shooting" :src="url" />
        <div class="trigger-container" @click="toggleFullscreen(index)"></div>
      </div>

      <v-btn fab small class="buttons ml-5" @click="$emit('change-image', 'NEXT')">
        <v-icon>arrow_right</v-icon>
      </v-btn>
    </div>

    <v-btn class="close-btn" fab small @click="toggleFullscreen(index)">
      <v-icon>close</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'ShootingGalleryItemFullscreen',
  props: {
    url: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: 0
    }
  },
  methods: {
    toggleFullscreen(index) {
      this.$emit('toggle-fullscreen', false, index)
    }
  }
}
</script>

<style lang="less" scoped>
.fullscreen-image {
  position: fixed;
  z-index: 997;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
}

.fullscreen-image__inner {
  position: relative;
  width: 80%;
  height: 80%;
  overflow: hidden;
  z-index: 998;
  display: flex;
  justify-content: center;
  align-items: center;
}

.buttons {
  position: relative;
  z-index: 1000;
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .fullscreen-image img {
    transform: translate(-50%, -50%);
  }
}

.fullscreen-image img {
  position: absolute;
  max-width: 100%;
  max-height: 100%;
  z-index: 1000;
}

.trigger-container {
  position: fixed;
  top: 0;
  left: 0;
  cursor: pointer;
  width: 100%;
  height: 100%;
  z-index: 999;
}

.close-btn {
  position: fixed;
  z-index: 1000;
  top: 25px;
  right: 25px;
}
</style>
